import { urlConst } from '../consts';
import { apiService } from './api.service';

export const userService = {
    login,
    loginByVk,
    logout,
    register,
    getInfo,
    update,
};

function login(username, password) {
    return apiService.post(urlConst.API_USER_AUTH, JSON.stringify({ username, password })).then((user) => {
        return user;
    });
}

function logout() {
    return apiService.get(urlConst.API_USER_LOGOUT);
}

function getInfo() {
    return apiService.get(urlConst.API_USER_GET);
}

function register(user) {
    return apiService.post(urlConst.API_USER_CREATE, JSON.stringify(user));
}

function update(data) {
    return apiService.put(urlConst.API_USER_UPDATE, JSON.stringify(data));
}

function loginByVk(data) {
    return apiService.post(urlConst.API_USER_AUTH_BY_VK, JSON.stringify(data)).then((user) => {
        return user;
    });
}
